module.exports = __webpack_public_path__ + "img/opera.ee912b84.svg";